exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress[data-v-6203ffb4]{position:fixed;top:0;left:0;right:0;height:3px;width:0;-webkit-transition:width .4s ease;transition:width .4s ease;-webkit-box-shadow:0 0 10px rgba(119,182,255,.7);box-shadow:0 0 10px rgba(119,182,255,.7);opacity:1;background-color:#77b6ff;z-index:999999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6203ffb4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Loading.vue
// module id = 47/y
// module chunks = 1